"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMarkersFromFeaturesArray = void 0;
const makeMarkersFromFeaturesArray = (features, map, onMarkerClick) => {
    const pointFeatures = features.filter((feature) => { var _a; return ((_a = feature.geometry) === null || _a === void 0 ? void 0 : _a.type) === "Point"; });
    if (pointFeatures.length) {
        const markers = pointFeatures.map((feature) => {
            return {
                coordinates: [...feature.geometry.coordinates],
                onClick: (event) => {
                    onMarkerClick(event, feature, map);
                },
            };
        });
        return markers;
    }
    return [];
};
exports.makeMarkersFromFeaturesArray = makeMarkersFromFeaturesArray;
